/**
 * Time-control classification, ported verbatim from PlayChess
 * `classifyTimeControl` (src/Screens/PlayChess/index.js L137-150). Both
 * arguments are MILLISECONDS.
 */
export function classifyTimeControl(
  durationMs: number,
  incrementMs: number,
): 'Bullet' | 'Blitz' | 'Rapid' | 'Classical' {
  // Calculate the total time in minutes
  const totalTime = (durationMs + incrementMs) / 60000;

  if (totalTime < 3) {
    return 'Bullet';
  } else if (totalTime < 10) {
    return 'Blitz';
  } else if (totalTime < 30) {
    return 'Rapid';
  } else {
    return 'Classical';
  }
}

/**
 * The time-control string PlayChess builds for the lobby (L3140-3141). Note
 * it prints SECONDS on both sides ("300 + 3" for 5+3) — kept for parity.
 */
export function tcLabel(durationMs: number, incrementMs: number): string {
  return `${(durationMs / 1000).toString()} + ${(
    incrementMs / 1000
  ).toString()}`;
}
